import { API_GRAPHQL } from '../../constants';
import { axiosAuthFetch } from '../../helpers/axios';

export async function GetSingleMealInfo(id) {

    const query = `
        query{
            meal(id:${id}){
                data{
                    id
                    attributes{
                        name
                        description
                        prep_time
                        cooking_time
                        serving
                        cooking_instructions
                        preparation
                        category
                        meal_instances(pagination: { limit: 100 }){
                            data{
                                id
                                attributes{
                                    custom_ingredients
                                    variant_name
                                    description
                                    clients{
                                        data{
                                            id
                                            attributes{
                                                username
                                                profile_picture{
                                                    data{
                                                        id
                                                        attributes{
                                                            url
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        meal_ingredients{
                            data{
                                id
                                attributes{
                                    unit
                                    amount
                                    ingredients{
                                        data{
                                            id
                                            attributes{
                                                name
                                                macros{
                                                    protein
                                                    fat
                                                    carbs
                                                    kcals
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        meal_images{
                            data{
                                attributes{
                                    image{
                                        data{
                                            attributes{
                                                url
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        clients(pagination: {limit: 50}) {
                            data{
                                id
                                attributes{
                                    username
                                }
                            }
                        }
                    }
                }
            }
        }
    `;

    const response = await axiosAuthFetch(API_GRAPHQL, { query }, 'post');
    
    return(response.data.meal.data);

}

export async function ClientSingleMeal(id) {

    const query = `
        query{
            meal(id:${id}){
                data{
                    id
                    attributes{
                        name
                        description
                        prep_time
                        cooking_time
                        serving
                        cooking_instructions
                        preparation
                        category
                        meal_ingredients{
                            data{
                                id
                                attributes{
                                    unit
                                    amount
                                    ingredients{
                                        data{
                                            id
                                            attributes{
                                                name
                                                macros{
                                                    protein
                                                    fat
                                                    carbs
                                                    kcals
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        meal_images{
                            data{
                                attributes{
                                    image{
                                        data{
                                            attributes{
                                                url
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `;

    const response = await axiosAuthFetch(API_GRAPHQL, { query }, 'post');
    console.log('MAIN',response);
    return(response.data.meal.data);

}

export async function ClientSingleInstance(id) {
    const query = `
        query{
            mealInstance(id:${id}){
                data{
                    id
                    attributes{
                        kcals
                        proteins
                        fats
                        carbs
                        variant_name
                        description
                        custom_ingredients
                        meal{
                            data{
                                id
                                attributes{
                                    name
                                    description
                                    prep_time
                                    cooking_time
                                    serving
                                    cooking_instructions
                                    preparation
                                    category
                                    meal_ingredients{
                                        data{
                                            id
                                            attributes{
                                                unit
                                                amount
                                                ingredients{
                                                    data{
                                                        id
                                                        attributes{
                                                            name
                                                            macros{
                                                                protein
                                                                fat
                                                                carbs
                                                                kcals
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    meal_images{
                                        data{
                                            attributes{
                                                image{
                                                    data{
                                                        attributes{
                                                            url
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `
    const response = await axiosAuthFetch(API_GRAPHQL, { query }, 'post');
    console.log('INSTANCE',response.data.mealInstance.data);
    return(response.data.mealInstance.data);
}